<template>
    <div class="">
        <b-badge v-for="(reservation, indexx) in reserved" :key="indexx"
                 variant="warning"
                 pill >
            {{ reservation.user_name.name }} |
            {{ reservation.date_start.date | moment("DD/MM/YY") }} -
            {{ reservation.date_end.date | moment("DD/MM/YY") }}
            <b-icon v-if="user.id === reservation.user_name.id"
                    icon="x-circle-fill"
                    variant="gray" title="smazat" class="pointer" @click="deleteItem(reservation.id)"></b-icon>
        </b-badge>
        <b-input-group class="mb-2 mt-2" size="sm">
            <b-form-datepicker
                v-model="reserveStart"
                aria-controls=""
                right
                start-weekday="1"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                placeholder="Půjčím"
            ></b-form-datepicker>
            <b-form-datepicker
                v-model="reserveEnd"
                aria-controls=""
                right
                placeholder="Vrátím"
                start-weekday="1"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            ></b-form-datepicker>
            <b-input-group-append>
                <b-button variant="info" size="sm" @click="reserve()">Rezervovat</b-button>
            </b-input-group-append>
        </b-input-group>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "reserve-item",
    props: {
        reserved: Array,
        idGarageMaterial: Number,
    },
    data() {
        return {
            reserveStart: null,
            reserveEnd: null,
            user: {}
        }
    },
    methods: {
        async reserve() {
            
            if (this.reserveStart > this.reserveEnd) {
                this.$eventHub.$emit('openMessageController', 'error', 'Datum začátku půjčení musí být menší nebo rovný datumu vrácení.');
                return;
            }
    
            if (this.reserveStart === null || this.reserveEnd === null) {
                this.$eventHub.$emit('openMessageController', 'error', 'Vyplň oba datumy.');
                return;
            }
            
            let data = {
                id_garage_material: this.idGarageMaterial,
                date_start: this.reserveStart,
                date_end: this.reserveEnd,
            };
        
            try {
                await axios({
                    url: process.env.VUE_APP_SERVER + 'garage-material/reserve-item.php',
                    headers: {'content-type': 'application/x-www-form-urlencoded'},
                    data: data,
                    method: 'PUT'
                });
                await this.$emit('refresh');
                this.reserveStart = null;
                this.reserveEnd = null;
                this.$eventHub.$emit('openMessageController', 'success', 'Rezervováno');
            
            } catch (error) {
                console.log("error", error);
                this.$eventHub.$emit('openMessageController', 'error', error.response.data.message);
            }
        
        
        },
        async deleteItem(id) {
            try {
                if (confirm("Opravdu smazat?")) {
                    await axios({
                        url: process.env.VUE_APP_SERVER + 'garage-material/delete-reservation.php',
                        headers: {'content-type': 'application/x-www-form-urlencoded'},
                        data: {'id': id},
                        method: 'DELETE'
                    });
    
                    await this.$emit('refresh');
                    this.$eventHub.$emit('openMessageController', 'success', 'Rezervace byla smazána');
                }
            } catch (error) {
                console.log("error", error);
                this.$eventHub.$emit('openMessageController', 'error', 'Operace se nezdařila');
            }
        
        },
    },
    created() {
        this.user = this.$store.state.user;
    }
}
</script>

<style lang="scss" scoped>
    .badge {
        margin-right: 3px;
        line-height: 1.1;
    }
    .pointer {
        cursor: pointer;
    }
</style>